<template>
    <b-container :id="trigger" class="Project">
        <b-row class="row-reverse">
            <b-col class="projectImgDiv" md="12" lg="6">
                <img :id="anim" class="projectImg" :src="getImgUrl(img)" :alt="alt">
                <!-- <img class="projectImgBg" :src="getImgUrl(bg)" :alt="alt"> -->
            </b-col>
            <b-col md="12" lg="6" class="projectTxt">
                <img :id="animlogo" class="projectLogo" :src="getImgUrl(logo)" :alt="alt">
                <p class="projectTitle">{{title}}</p>
                <p class="projectP">{{msg}}</p>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
    name:'Project',
    props: {
        bg: String,
        alt: String,
        img: String,
        title:String,
        msg:String,
        logo:String,
        numb:Number,
        trigger:String,
        anim:String,
        animlogo:String
    },
    methods: {
        getImgUrl: function(img) {
            return require('@/assets/imagesHome/'+img)
        }
    },
    mounted() {
        const scene = this.$scrollmagic.scene({
          triggerElement: '#triggerHundai',
          duration: 200
        })
        .setTween( "#animHundai", 0.5, {width:'100%', opacity:1})
        // .addIndicators({ name: 'Anim hundai image (duration: 400)' })

        const scene2 = this.$scrollmagic.scene({
          triggerElement: '#animHundai',
          duration: 200
        })
        .setTween( "#animLogoHundai", 0.5, {width:'120px', opacity:1})
        // .addIndicators({ name: 'Anim hundai logo (duration: 400)' })

        const scene3 = this.$scrollmagic.scene({
          triggerElement: '#triggerMD',
          duration: 200
        })
        .setTween( "#animMD", 0.5, {width:'100%', opacity:1})
        // .addIndicators({ name: 'Anim MD image (duration: 400)' })

        const scene4 = this.$scrollmagic.scene({
          triggerElement: '#animMD',
          duration: 200
        })
        .setTween( "#animLogoMD", 0.5, {width:'120px', opacity:1})
        // .addIndicators({ name: 'Anim MD logo (duration: 400)' })

        const sceneEn = this.$scrollmagic.scene({
          triggerElement: '#triggerEnergizer',
          duration: 200
        })
        .setTween( "#animEnergizer", 0.5, {width:'100%', opacity:1})
        // .addIndicators({ name: 'Anim Energizer image (duration: 400)' })

        const sceneEnlogo = this.$scrollmagic.scene({
          triggerElement: '#animEnergizer',
          duration: 200
        })
        .setTween( "#animLogoEnergizer", 0.5, {width:'120px', opacity:1})
        // .addIndicators({ name: 'Anim Energizer logo (duration: 400)' })

        const sceneSw = this.$scrollmagic.scene({
          triggerElement: '#triggerSwap',
          duration: 200
        })
        .setTween( "#animSwap", 0.5, {width:'100%', opacity:1})
        // .addIndicators({ name: 'Anim Swap image (duration: 400)' })

        const sceneSwlogo = this.$scrollmagic.scene({
          triggerElement: '#animSwap',
          duration: 200
        })
        .setTween( "#animLogoSwap", 0.5, {width:'200px', opacity:1})
        // .addIndicators({ name: 'Anim Swap logo (duration: 400)' })

        this.$scrollmagic.addScene([scene, scene2 ,scene3, scene4, sceneEn, sceneEnlogo, sceneSw, sceneSwlogo])
    }
}
</script> 

<style scoped lang="scss">
@import '@/assets/style/projects.scss';
</style>